import React, { useMemo } from 'react'
import moment from 'moment'
import { KTSVG } from '../../../../../_metronic/helpers'
import { useIntl } from 'react-intl'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
dayjs.extend(utc)
dayjs.extend(timezone)

const getFileIcon = (extension: string) => {
  switch (extension.toLowerCase()) {
    case 'mp4':
      return '/media/icons/duotone/General/live_tv.svg'
    case 'mdt':
      return '/media/icons/duotone/General/video_file.svg'
    case 'jpeg':
      return '/media/icons/duotone/General/image.svg'
    case 'jpg':
      return '/media/icons/duotone/General/image.svg'
    default:
      return '/media/icons/duotone/Files/File.svg'
  }
}

const getFileIconClass = (extension: string) => {
  switch (extension.toLowerCase()) {
    case 'mp4':
      return 'icon mp4-icon'
    case 'mdt':
      return 'icon mdt-icon'
    case 'jpg':
    case 'jpeg':
      return 'icon jpg-icon'
    default:
      return 'icon'
  }
}

const extractExtension = (url: string) => {
  try {
    const pathname = new URL(url).pathname
    const lastSegment = pathname.substring(pathname.lastIndexOf('/') + 1)
    const dotIndex = lastSegment.lastIndexOf('.')
    return dotIndex !== -1 ? lastSegment.substring(dotIndex + 1) : ''
  } catch {
    return ''
  }
}

const MagicLinksRow: React.FC<any> = ({
  link,
  index,
  setShow,
  setLocation,
}) => {
  const intl = useIntl()
  const file = link.file || {}

  const extension = useMemo(() => {
    if (!file?.fileAccessLink) return ''
    return extractExtension(file.fileAccessLink)
  }, [file?.fileAccessLink])

  const iconPath = useMemo(() => {
    return getFileIcon(extension)
  }, [extension])

  const iconClass = useMemo(() => {
    return getFileIconClass(extension)
  }, [extension])

  const extractVehicleNo = (title: string) => {
    const match = title.match(/vehicle:\s*(.*)$/i)
    return match ? match[1].trim() : '-'
  }

  return (
    <>
      <tr
        className='hover-effect'
        onClick={() => {
          if (file?.fileAccessLink) {
            window.open(file.fileAccessLink, '_blank')
          }
        }}
      >
        <td className='file-index'>
          <div className='index'>{index + 1}</div>
        </td>

        <td className='file-title'>{file.title ? extractVehicleNo(file.title) : '-'}</td>
        <td>
          {file.startEpoch
            ? dayjs.unix(file.startEpoch).utc().tz(dayjs.tz.guess()).format('YYYY-MM-DD, HH:mm:ss')
            : '-'}
        </td>
        <td>
          {file.startEpoch && file.endEpoch
            ? moment.unix(file.endEpoch).diff(moment.unix(file.startEpoch), 's') + 's'
            : '-'}
        </td>
        <td className='file-type'>
          <span className='d-flex align-items-center extension'>
            <KTSVG path={iconPath} className={iconClass} fill='currentColor' />
            <span className='file-extension'>
              {extractExtension(file.fileAccessLink).toUpperCase() ?? ''}
            </span>
          </span>
        </td>
        <td className='d-flex align-items-center'>
          {file?.startLat &&
            file?.startLong &&
            !isNaN(Number(file.startLat)) &&
            !isNaN(Number(file.startLong)) ? (
            <div
              onClick={(e) => {
                e.stopPropagation()
                setShow(true)
                setLocation({
                  Lat: file.startLat,
                  Long: file.startLong,
                })
              }}
              className='cursor-pointer'
            >
              <KTSVG
                path={'/media/icons/duotone/General/Transportation.svg'}
                className='svg-icon-2'
              />
              <span className='ml-4'>{intl.formatMessage({ id: 'GENERAL.LABEL.VIEW' })}</span>
            </div>
          ) : (
            '-'
          )}
        </td>
        <td>{file.deviceId ? file.deviceId : '-'}</td>
        <td>{file.type ? file.type.toLowerCase() : '-'}</td>
        <td>{link.fileStatus ? link.fileStatus.toLowerCase() : '-'}</td>
      </tr>
    </>
  )
}

export default MagicLinksRow
